import { ActionTypes } from "../action-type";

const initialState = {
    status: 0,
  };

export const headerReducer = (state = initialState, action)=>{
    switch (action.type) {
        case ActionTypes.HEADER_LENGTH:
          return { ...state, status: action.payload };
        default:
          return state;
    }
};